import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';

const RoofHelpModal = ({ rhModalIsOpen, closeRHModal }) => {
    return (
        <Modal
            show={rhModalIsOpen}
            onHide={closeRHModal}
            backdrop='static'
            size='lg'
            centered
            scrollable
            contentClassName='background'
        >
            <Modal.Header>
                <Modal.Title>Roof Direction</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>The direction that your roof faces is very important in these calculations, so the more accurate you can be when you give us the direction, the more accurate the output will be.</p>
                <p>Although some of you may have a compass, there are compass apps on most modern mobile phones that will give an accurate reading.</p>
                <p>The iPhone version is called Compass, and there are many available on Android, including Compass Galaxy, shown below:</p>
                <div className='app-icon-image-box'>
                    <Image src='https://res.cloudinary.com/dujftalas/image/upload/c_scale,w_108/v1677622738/compass_app_apple_y9nm6h.png' />
                    <Image src='https://res.cloudinary.com/dujftalas/image/upload/c_scale,w_108/v1678830292/Screenshot_2023-03-14_at_21.41.45_xrtedk.png' />
                </div>
                <p>Stand with your back to the roof where the panels will be mounted and measure the bearing that they face. For example, a south facing roof will have a bearing of 180°.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button className='modal-button' onClick={closeRHModal}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RoofHelpModal;
